import { createFileRoute } from "@tanstack/react-router";
import { EnvPreset } from "gfx/EnvPreset";
import { envPresetSceneLights } from "gfx/sceneLights";
import withCustomizer from "lib/state/withCustomizer";
import { HeadlessRenderTestPage } from "test/util/HeadlessRenderTestPage";
import {
  addPlanRenderTestTHREEGeometry,
  PLAN_RENDER_TEST_CAMERA_SETTINGS,
  PLAN_RENDER_TEST_KEYS,
} from "test/util/planRenderUtil";
import withAuthentication from "../../components/withAuthentication";

function PlanRenderPage() {
  const options = {
    gui: false,
    ssfxRenderer: true,
    animate: true,
    sceneLights: envPresetSceneLights[EnvPreset.WHITEBOX],
    debugFeaturesEnabled: false,
    cameraSettings: PLAN_RENDER_TEST_CAMERA_SETTINGS,
    useMSAA: false,
  };

  return (
    <HeadlessRenderTestPage
      testName="Plan Render"
      options={options}
      testKeys={PLAN_RENDER_TEST_KEYS}
      addGeometry={addPlanRenderTestTHREEGeometry}
    />
  );
}

export const Route = createFileRoute("/debug/plan-render")({
  component: withAuthentication(withCustomizer(PlanRenderPage), { superAdmin: true }),
});
